import api from './config/api';
import axios from './config/axios';

export default {
    /**
     * Get website info by websiteId
     * @param websiteId
     * @returns { AxiosPromise }
     */
    getInfo( { websiteId } ) {
        return axios( {
            url: api.baseUrl( `portal/v1/website/${ websiteId }` ),
            method: 'get',
        } );
    },

    /**
     * Get the .json config file for a given website ( comes from getInfo() )
     * @param jsonFileName
     * @returns { AxiosPromise }
     */
    getConfig( { jsonFileName } ) {
        return axios( {
            url: `${ api.JSON_BASE_URL }/${ jsonFileName }`,
            method: 'get',
        } );
    },
};
